module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "p-paginator-current"
  }, [_vm._v(_vm._s(_vm.text))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b5b8cdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/paginator/CurrentPageReport.vue
// module id = 2210
// module chunks = 0